import { Box, Tabs, Tab } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { hasPermission } from 'store'

export const tabConfig = [
  { index: 0, label: 'Send Notification', path: 'send', permission: 'miscellaneous.notification' },
  { index: 1, label: 'Report', path: 'report', permission: 'miscellaneous.notification' },
]

export default function NotificationTabs() {
  const basePath = '/notification'
  const theme = useSelector(state => state.session.appearance)
  const { t } = useTranslation()
  const { '*': tabName } = useParams()

  const permittedTabs = tabConfig.filter(tab => hasPermission(tab.permission))

  const getTabIndex = path => {
    const [name] = (path ?? '').split('/')
    const found = permittedTabs.find(tab => tab.path === name)
    return found ? found.index : permittedTabs[0]?.index ?? 0
  }

  const [tabIndex, setTabIndex] = useState(getTabIndex(tabName))

  useEffect(() => {
    setTabIndex(getTabIndex(tabName))
  }, [tabName, permittedTabs.length])

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', displayPrint: 'none' }}>
        <Tabs value={tabIndex}>
          {permittedTabs.map(tab => (
            <Tab
              key={tab.path}
              sx={{ color: tabIndex === tab.index && 'primary !important' }}
              className={tabIndex === tab.index ? 'tab-item-selected' : `tab-item-${theme}`}
              label={t(tab.label)}
              value={tab.index}
              component={Link}
              to={`${basePath}/${tab.path}`}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  )
}
